import ObjectFitImages from 'object-fit-images';

// Object Fit all Hero image that has content in IE11-.
const images = document.querySelectorAll('.hero__image');
ObjectFitImages(images);
